import { CalendarClock } from "lucide-react";

const L = {
  fr: { title: "Rendez-vous radio", sub: "Les prochains épisodes sur cette chaîne", now: "En cours" },
  en: { title: "Radio schedule", sub: "Next episodes on this channel", now: "On air" },
  es: { title: "Programación", sub: "Próximos episodios en este canal", now: "En antena" },
  nl: { title: "Radiogids", sub: "Volgende afleveringen op dit kanaal", now: "Nu" },
};

// Calcule les 6 prochains épisodes de la grille et leur heure de début locale
export const upcoming = (program, pos, nowSec, count = 6) => {
  if (!program || !pos) return [];
  const n = program.items.length;
  const out = [];
  let t = nowSec + (pos.length - pos.offset);
  let i = pos.idx;
  if (pos.kind === "episode") { t += program.jingle; i = pos.nextIdx; }
  for (let k = 0; k < Math.min(count, n); k++) {
    out.push({ slug: program.items[i].slug, start: t });
    t += program.items[i].d + program.jingle;
    i = (i + 1) % n;
  }
  return out;
};

export const RadioSchedule = ({ program, pos, now, lang, byslug }) => {
  const T = L[lang] || L.fr;
  const rows = upcoming(program, pos, now);
  const hhmm = (s) => new Date(s * 1000).toLocaleTimeString(lang, { hour: "2-digit", minute: "2-digit" });
  if (!rows.length) return null;
  return (
    <div className="mt-6 glass rounded-3xl border border-white/10 p-5 sm:p-6" data-testid="radio-schedule">
      <h3 className="font-display text-2xl mb-1 flex items-center gap-2"><CalendarClock size={18} className="text-primary" /> {T.title}</h3>
      <p className="text-xs text-foreground/45 mb-4">{T.sub}</p>
      <ol className="divide-y divide-white/5">
        {rows.map((r, k) => {
          const ep = byslug[r.slug];
          if (!ep) return null;
          return (
            <li key={`${r.slug}-${k}`} className="flex items-center gap-4 py-2.5" data-testid={`radio-schedule-row-${k}`}>
              <span className="w-20 whitespace-nowrap text-sm tabular-nums text-primary/90 font-semibold">{hhmm(r.start)}</span>
              <img src={`/derive/covers/${r.slug}.jpg`} alt="" className="w-9 h-9 rounded-lg object-cover border border-primary/15" />
              <span className="flex-1 min-w-0 truncate text-sm text-foreground/85">{ep.title[lang] || ep.title.fr}</span>
            </li>
          );
        })}
      </ol>
    </div>
  );
};
